import React, { useContext, useEffect, useState } from 'react';
import "./chatList.scss";
import axios from 'axios';
import ChatItem from './../../components/Chat/ChatItem/ChatItem';
import { Context } from '../../context/userContext';
import { baseUrl } from '../../config/config';

const ChatList = () => {
    const {userInfo} = useContext(Context);
    const [users, setUsers] = useState([]);

    const fetchAllUserExceptCurrentUser = () => {
      axios.get(`${baseUrl}/message/room/${userInfo?.id}`)
      .then(response => {
        setUsers(response.data)
        console.log(response.data)
      })
      .catch(err => {
        console.log(err);
      })
    }

    useEffect(() => {
      if(userInfo) fetchAllUserExceptCurrentUser();
    }, [userInfo])

    return (
      <div className="main__chatlist">
        <div className="chatlist__heading">
          Ny Resako
        </div>
        <div className="chatlist__items">
          {users && users.map((item, index) => {
            return (
              <ChatItem
                chatRoomId={item.chatRoomId}
                usersId={item.usersId}
                key={index}
              />
            );
          })}
        </div>
      </div>
  )
}

export default ChatList;
